"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* Modal components  for Ryerson.com*/


var react_1 = __importStar(require("react"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_typography_1 = require("@ryerson/frontend.typography");

var rgba_1 = __importDefault(require("polished/lib/color/rgba"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var react_2 = require("@emotion/react");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_button_1 = require("@ryerson/frontend.button");

var Overlay = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: fixed;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tmax-width: 100vw;\n\tmax-height: 100vh;\n\n\tz-index: ", ";\n\n\t", ";\n"])), frontend_common_1.IndexedLayers.modal, function (props) {
  var backgroundColor = props.backgroundColor;
  return (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tbackground-color: ", ";\n\t\t"])), (0, rgba_1.default)(backgroundColor, 0.5));
});
var ModalContent = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\toverflow-y: auto;\n\n\tpadding: 0 40px;\n\n\t", ";\n"])), function (props) {
  var debugBorders = props.debugBorders,
      theme = props.theme;
  return (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\t", "\n\t\t\tbackground: ", ";\n\t\t\tcolor: ", ";\n\t\t"])), debugBorders && "border: 1px solid red;", theme.background, theme.text);
});

var Modal = function Modal(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      dataTestId = _ref.dataTestId,
      className = _ref.className,
      isOpen = _ref.isOpen,
      _ref$closable = _ref.closable,
      closable = _ref$closable === void 0 ? true : _ref$closable,
      children = _ref.children,
      buttonArea = _ref.buttonArea,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      _ref$bodyType = _ref.bodyType,
      bodyType = _ref$bodyType === void 0 ? "primary" : _ref$bodyType,
      _ref$modalStyle = _ref.modalStyle,
      modalStyle = _ref$modalStyle === void 0 ? "default" : _ref$modalStyle,
      onClose = _ref.onClose;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      white = _theme$colors$primary.white,
      gray = _theme$colors$primary.gray;
  var _theme$colors$type = theme.colors[type],
      background = _theme$colors$type.background,
      text = _theme$colors$type.text;
  var debugBorders = false;
  var innerModalStyle = (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\tborder-radius: 4px;\n\t\tbox-shadow: 0 0 16px 2px rgba(59, 59, 152, 0.1);\n\t\tbackground-color: ", ";\n\t\tz-index: ", ";\n\t\tmax-width: 90vw;\n\t\tmax-height: 90vh;\n\t\t@media only screen and (min-width: ", "px) {\n\t\t\tmax-width: ", ";\n\t\t}\n\t"])), white, frontend_common_1.IndexedLayers.modal, parseInt(theme.breakpoints.xl) * 1.25, theme.breakpoints.xl);
  var flexModalHeaderStyle = (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\tposition: relative;\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t\tborder-top-left-radius: 4px;\n\t\tborder-top-right-radius: 4px;\n\t\tpadding: ", ";\n\t"])), background, theme.colors[type].background, modalStyle === "default" ? "40px 70px 20px 40px" : "20px");
  var modalButtonAreaStyle = (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\tbackground-color: ", ";\n\t\tborder-bottom-left-radius: 4px;\n\t\tborder-bottom-right-radius: 4px;\n\t\tpadding: ", ";\n\t"])), background, modalStyle === "default" ? "20px 40px 40px" : "20px");
  var isMountedRef = (0, react_1.useRef)();
  var modalRef = (0, react_1.createRef)();

  var _ref3 = (0, react_1.useState)(isOpen),
      _ref4 = _slicedToArray(_ref3, 2),
      open = _ref4[0],
      setOpen = _ref4[1];

  var _ref5 = (0, react_1.useState)(isOpen),
      _ref6 = _slicedToArray(_ref5, 2),
      bodyStyles = _ref6[0],
      setBodyStyles = _ref6[1];

  var handleClose = function handleClose(event) {
    if (isOpen && closable && modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  react_1.default.useEffect(function () {
    setOpen(isOpen); // Stops background from scrolling when scrolling modal

    if (isOpen) {
      var body = document.querySelector("body");
      setBodyStyles(body === null || body === void 0 ? void 0 : body.getAttribute("style"));
      body && body.setAttribute("style", "height: 100vh; overflow-y: hidden;");
      document.addEventListener("mousedown", handleClose, {
        once: true
      });
    } else {
      var _body = document.querySelector("body");

      _body && _body.setAttribute("style", bodyStyles);
      document.removeEventListener("mousedown", handleClose);
    } // eslint-disable-next-line

  }, [isOpen]);
  react_1.default.useEffect(function () {
    return function () {
      var body = document.querySelector("body");
      body && body.setAttribute("style", bodyStyles);
    };
  }, []);
  return open ? (0, jsx_runtime_1.jsx)("div", {
    "data-testid": dataTestId,
    className: "modal-component-root ".concat(className && (className || "")),
    children: (0, jsx_runtime_1.jsx)(Overlay, {
      className: "modal-component-overlay",
      onMouseDown: handleClose,
      backgroundColor: gray,
      children: (0, jsx_runtime_1.jsx)("div", {
        className: "click-shield",
        ref: modalRef,
        children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          css: innerModalStyle,
          direction: "column",
          children: [title && (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            css: flexModalHeaderStyle,
            alignItems: "center",
            justifyContent: "space-between",
            children: [modalStyle === "default" && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              type: type,
              variant: "h2",
              children: title
            }), modalStyle === "dialog" && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              type: type,
              children: title
            }), closable && modalStyle === "default" && (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
              css: (0, react_2.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\t\t\t\ttop: 20px;\n\t\t\t\t\t\t\t\t\t\t\tright: 20px;\n\t\t\t\t\t\t\t\t\t\t"]))),
              background: gray,
              foreground: "light",
              type: "secondary",
              leftIcon: "close",
              shape: "circle",
              label: "",
              onClick: onClose,
              size: "sm"
            }), closable && modalStyle === "dialog" && (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
              css: (0, react_2.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\tmargin-left: ", ";\n\t\t\t\t\t\t\t\t\t\t"])), frontend_layout_1.DEFAULT_PADDING),
              icon: "close",
              color: text,
              onClick: onClose
            })]
          }), (0, jsx_runtime_1.jsx)(ModalContent, {
            debugBorders: debugBorders,
            theme: theme.colors[bodyType],
            ref: isMountedRef,
            children: children
          }), buttonArea && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
            css: modalButtonAreaStyle,
            alignItems: "center",
            justifyContent: "center",
            children: buttonArea
          })]
        })
      })
    })
  }) : null;
};

exports.Modal = Modal;